/* Banner link headings */
// for use with .bannerlink styling in bannerlink.scss
// Adapts to Ghost's image insertion function in posts
// and automatically links to the hash link of the caption/title.
// Example banner headers in LTM Applications & Flyers page.

const bannerlink = function(documentElem) {

  function initBannerlink() {
    const figures = document.querySelectorAll(
      '.bannerlink figure'
    );

    figures.forEach(function (figure) {
      var captionA = figure.querySelector('figure > a');
      if (!captionA) {
        captionA = document.createElement('a');
        const img = figure.querySelector('figure img');
        img.parentNode.replaceChild(captionA, img);
        captionA.appendChild(img);
      }
      var caption = figure.querySelector('figcaption');
      var linkId = caption.textContent.toLowerCase().replaceAll(' ','-');
      captionA.setAttribute('href', "#" + linkId);
      captionA.setAttribute("aria-label", "Go to section");
    })
  }

  return {
    init: initBannerlink
  }
}
